import { render, staticRenderFns } from "./CalendarShiftList.vue?vue&type=template&id=70f71770&"
import script from "./CalendarShiftList.vue?vue&type=script&lang=js&"
export * from "./CalendarShiftList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports